
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parking/pressroom",
      function () {
        return require("private-next-pages/parking/pressroom/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parking/pressroom"])
      });
    }
  